import * as Yup from "yup";

import { Modal, OfficeButton } from "components";
import {
    UpdateUserRole,
    UpdateUserRoleVariables,
} from "_graphql/queries/kek/__generated__/UpdateUserRole";

import { CreateUserRoleContainerProps } from "./create";
import CreateUserRoleForm from "components/forms/create-user-role";
import { LocationGenerics } from "router/location";
import toast from "react-hot-toast";
import { updateUserRole } from "_graphql/kek/queries/roles.kek";
import { useEffect } from "react";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useRole } from "hooks/data/use-roles";
import { useSearch } from "react-location";
import { wrapClick } from "utils";

export const revalidationSchema = Yup.object().shape({
    position: Yup.string().required("Position is required"),
    privileges: Yup.array()
        .min(1)
        .required("At least one privilege is required"),
});

export default function UpdateUserRoleContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const { role, loading: loadingRole } = useRole(
        (searchParams?.id as string) || ""
    );

    const [update, { loading }] = useMutation<
        UpdateUserRole,
        UpdateUserRoleVariables
    >(updateUserRole, {
        refetchQueries: ["User_roles"],
    });

    const form = useFormik<CreateUserRoleContainerProps>({
        initialValues: {
            position: "",
            privileges: [],
        },
        validationSchema: revalidationSchema,
        onSubmit: async (values) => {
            await update({
                variables: {
                    userRoleId: searchParams.id,
                    position: values.position,
                    privileges: btoa(JSON.stringify(values.privileges)),
                },
            }).then(({ data }) => {
                if (data?.updateUserRole) {
                    toast.success("User Role Updated Successfully");
                    refetch?.();
                    form.resetForm();
                } else {
                    toast.error("Failed to update User Role");
                }
            });
        },
        onReset: () => {
            setOpen(false);
        },
    });

    useEffect(() => {
        form.setValues({
            position: role?.position || "",
            privileges: (() => {
                try {
                    const base64 = role?.privileges;
                    if (!base64) return [];
                    return JSON.parse(atob(base64));
                } catch {
                    return [];
                }
            })(),
        });
    }, [loadingRole, role]);
    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={loadingRole}
            title="Update User Role"
            description="Provide the details to update the user role"
            renderActions={() => (
                <>
                    <OfficeButton disabled={loading}
                        onClick={wrapClick(form.handleSubmit)}>
                        {loading ? "Updating User Role..." : "Update User Role"}
                    </OfficeButton>
                </>
            )}>
            <CreateUserRoleForm form={form} />
        </Modal>
    );
}
